import {
  BundleLineIdSchema,
  BundleLineSchema,
  BundleLineVariant,
  BundleLineVariantIdSchema,
  BundleSchema,
  QuantitySchema,
} from "@greeter/core";
import { JsonMapSchema } from "@greeter/json";
import z from "zod";

export type CartLineId = string;

export const PickDataSchema = z.object({
  type: z.union([z.literal("extra"), z.literal("normal")]),
  quantity: QuantitySchema,
  additionalPrice: z.number(),
});
export type PickData = z.infer<typeof PickDataSchema>;

export const QuantityPicksSchema = JsonMapSchema(
  BundleLineVariantIdSchema,
  z.array(PickDataSchema)
);
export type QuantityPicks = z.infer<typeof QuantityPicksSchema>;

export const VariantPicksSchema = JsonMapSchema(
  BundleLineIdSchema,
  QuantityPicksSchema
);
export type VariantPicks = z.infer<typeof VariantPicksSchema>;

export const BundleLineFormSchema = BundleLineSchema.extend({
  extra: z
    .array(
      z.object({
        bundleLineId: BundleLineIdSchema,
        bundleLineVariantId: BundleLineVariantIdSchema,
        quantity: QuantitySchema,
      })
    )
    .default([]),
});
export type BundleLineForm = z.infer<typeof BundleLineFormSchema>;

export const BundleFormSchema = BundleSchema.extend({
  lines: z.array(BundleLineFormSchema),
});
export type BundleForm = z.infer<typeof BundleFormSchema>;
